import { Link, useNavigate } from "react-router-dom";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { useEffect, useState } from "react";
import { GetDahsboard, GetGuadinaSetList, ResubmitWill } from "../../api/get";
import Loader from "../../loader";
import Header from "../../Common/Header";
import toast, { Toaster } from "react-hot-toast";
import { handleApiError } from "../../Common/Helper";
const Dashboard = (props) => {
  const [seeMore, setSeeMore] = useState(false);
  const [seeMoreAsset, setSeeMoreAsset] = useState(false);
  const [seeMoreGift, setSeeMoreGift] = useState(false);
  const [seeMoreGaurdian, setSeeMoreGaurdian] = useState(false);
  const [DashboardData, setDashboardData] = useState(null);
  const [contentLoder, setContentLoader] = useState(true);
  const [guardianSetList, setGuardianSetList] = useState([]);
  const [refresh, setRefresh] = useState(false); // Track changes
  const navigate = useNavigate();

  useEffect(() => {
    // Call both APIs concurrently
    Promise.all([GetDahsboard(), GetGuadinaSetList()])
      .then(([dashboardRes, guardianRes]) => {
        if (
          dashboardRes.success &&
          guardianRes.success &&
          dashboardRes.status_code === "200" &&
          guardianRes.status_code === "200"
        ) {
          setDashboardData(dashboardRes.data); // Set Dashboard Data
          setGuardianSetList(guardianRes.data); // Set Guardian Set List
          setContentLoader(false); // Hide loader when both APIs are done
        } else if (!dashboardRes.success) {
          handleApiError(dashboardRes, navigate); // Use helper function
        } else if (!guardianRes.success) {
          handleApiError(guardianRes, navigate); // Use helper function
        }
      })
      .catch((err) => {
        console.log("Error fetching data:", err);
        setContentLoader(false); // Hide loader even if one API fails
      });
  }, [refresh]);

  const handleResubmitWill = (will_id, note_id = null) => {
    ResubmitWill(will_id, note_id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setRefresh((prev) => !prev);
          toast.success(
            "Will Updated successfully, Now You Are in Review mode"
          );
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("An error occurred");
      });
  };
  console.log("guardianSetList =>", guardianSetList);
  const { child, pets } = guardianSetList || {};
  const firstData =
    (child && child.length > 0 ? child[0] : pets && pets[0]) || {};
  return (
    <>
      {contentLoder ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 max-lg:grid-cols-1">
              <div>
                <div className="mt-5">
                  <h4 className="text-[24px] sm:text-[24px] lg:text-[30px] font-bold font-muli text-start sm:text-left">
                    Great progress, {DashboardData.family.owner_details?.name}!
                  </h4>
                  <p className="text-[16px] sm:text-[18px] lg:text-[20px] text-slate-500 font-muli text-start sm:text-left mt-2">
                    Not too far to go — just a few more details.
                  </p>
                  <div className="mt-5">
                    <div className="w-full bg-[#d7d7d7] rounded-full h-2.5 dark:bg-gray-700">
                      <div
                        className="bg-primary h-2.5 rounded-full"
                        style={{ width: `${DashboardData?.total_percentage}%` }}
                      ></div>
                    </div>
                    <p className="font-muli mt-2 text-[12px] sm:text-[14px] lg:text-[16px] text-start sm:text-left">
                      {DashboardData.total_percentage}% progress
                    </p>
                  </div>
                  {DashboardData.issue === "true" && (
                    <div className="mt-5">
                      <div className="w-full text-[18px] font-semibold mt-4 bg-[#f44336] text-white p-3 rounded">
                        <div>
                          You need to update a few details in your will.
                        </div>
                        <div className="mt-2">
                          <button
                            className="text-[16px] text-white underline font-bold hover:text-gray-200 transition-colors duration-200"
                            onClick={() => {
                              navigate('/make-will-online/execution/errors')
                            }}
                          >
                            View More
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="my-5">
                  <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                    {DashboardData.aboutYourself === "Edit" ? (
                      <>
                        <div className="flex items-center justify-between mt-[16px]">
                          <h4 className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold">
                            Your family
                          </h4>
                          {(DashboardData?.willStatus == "in_process" ||
                            DashboardData?.willStatus == "in_updating") && (
                            <div>
                              <Link
                                to={"/make-will-online/about-yourself/review"}
                              >
                                <button className="border-2 border-[#240642] rounded-[5px] text-[#240642] px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  Edit
                                </button>
                              </Link>
                            </div>
                          )}
                        </div>
                        <div className="">
                          <div className="">
                            <p className="text-[16px] sm:text-[16px] lg:text-[18px]  font-bold">
                              The owner of this will
                            </p>

                            <div className="flex mt-4 w-full">
                              <div className="w-[40%]">
                                <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  Name
                                </p>
                              </div>
                              <div className="w-[60%]">
                                <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  {DashboardData.family.owner_details?.name}
                                </p>
                              </div>
                            </div>
                            <div className="flex mt-2 w-full">
                              <div className="w-[40%]">
                                <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  Date of birth
                                </p>
                              </div>
                              <div className="w-[60%]">
                                <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  {new Date(
                                    DashboardData.family.owner_details?.dob
                                  ).toLocaleDateString("en-GB")}
                                </p>
                              </div>
                            </div>
                            <div className="flex mt-2 w-full">
                              <div className="w-[40%]">
                                <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  Marital status
                                </p>
                              </div>
                              <div className="w-[60%]">
                                <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  {
                                    DashboardData.family.owner_details
                                      ?.marital_status
                                  }
                                </p>
                              </div>
                            </div>
                            <div className="flex mt-2 w-full">
                              <div className="w-[40%]">
                                <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  Email
                                </p>
                              </div>
                              <div className="w-[60%]">
                                <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  {DashboardData.family.owner_details?.email}
                                </p>
                              </div>
                            </div>
                            <div className="flex mt-2 w-full">
                              <div className="w-[40%]">
                                <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  Address
                                </p>
                              </div>
                              <div className="w-[60%]">
                                <p className="font-semibold w-[60%] text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  {[
                                    DashboardData.family.owner_details
                                      ?.address_line_1,
                                    DashboardData.family.owner_details
                                      ?.address_line_2,
                                    DashboardData.family.owner_details
                                      ?.postcode,
                                    DashboardData.family.owner_details?.city,
                                  ]
                                    .filter(Boolean) // Filters out null, undefined, or empty strings
                                    .join(", ")}
                                </p>
                              </div>
                            </div>
                            {!seeMore ? (
                              <div className="mt-1">
                                <button
                                  onClick={() => {
                                    setSeeMore(true);
                                  }}
                                  className="underline font-semibold"
                                >
                                  See More
                                </button>
                              </div>
                            ) : (
                              ""
                            )}
                            {seeMore === true ? (
                              <div>
                                {DashboardData.family.partner_details &&
                                  Object.keys(
                                    DashboardData.family.partner_details
                                  ).length > 0 && (
                                    <div className="mt-2">
                                      <p className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold">
                                        Your partner
                                      </p>
                                      {DashboardData.family.partner_details
                                        ?.name && (
                                        <div className="flex mt-2 w-full">
                                          <div className="w-[40%]">
                                            <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              Name
                                            </p>
                                          </div>
                                          <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                            {
                                              DashboardData.family
                                                .partner_details?.name
                                            }
                                          </p>
                                        </div>
                                      )}
                                      {DashboardData.family.partner_details
                                        ?.dob && (
                                        <div className="flex mt-2 w-full">
                                          <div className="w-[40%]">
                                            <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              Date of birth
                                            </p>
                                          </div>
                                          <div className="w-[60%]">
                                            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              {new Date(
                                                DashboardData.family.partner_details?.dob
                                              ).toLocaleDateString("en-GB")}
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                      {DashboardData.family.partner_details
                                        ?.email && (
                                        <div className="flex mt-2 w-full">
                                          <div className="w-[40%]">
                                            <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              Email
                                            </p>
                                          </div>
                                          <div className="w-[60%]">
                                            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              {
                                                DashboardData.family
                                                  .partner_details?.email
                                              }
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                      {DashboardData.family.partner_details
                                        ?.address && (
                                        <div className="flex mt-2 w-full">
                                          <div className="w-[40%]">
                                            <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              Address
                                            </p>
                                          </div>
                                          <div className="w-[60%]">
                                            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              {
                                                DashboardData.family
                                                  .partner_details?.address
                                              }
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                <div className="mt-2">
                                  {DashboardData.family.child_details.map(
                                    (child, index) => (
                                      <div key={index} className="mt-4">
                                        <p className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold">
                                          Your child
                                        </p>
                                        <div className="flex mt-2 w-full">
                                          <div className="w-[40%]">
                                            <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              Name
                                            </p>
                                          </div>
                                          <div className="w-[60%]">
                                            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              {child.name}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="flex mt-2 w-full">
                                          <div className="w-[40%]">
                                            <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              Date of birth
                                            </p>
                                          </div>
                                          <div className="w-[60%]">
                                            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              {new Date(
                                                child?.dob
                                              ).toLocaleDateString("en-GB")}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                                <div className="mt-2">
                                  {DashboardData.family.pets.map(
                                    (pet, index) => (
                                      <div key={index} className="mt-4">
                                        <p className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold">
                                          Your Pet
                                        </p>
                                        <div className="flex mt-2 w-full">
                                          <div className="w-[40%]">
                                            <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              Name
                                            </p>
                                          </div>
                                          <div className="w-[60%]">
                                            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              {pet?.pet_name}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="flex mt-2 w-full">
                                          <div className="w-[40%]">
                                            <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              Pet’s type
                                            </p>
                                          </div>
                                          <div className="w-[60%]">
                                            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                              {pet?.pet_type}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                                <div className="mt-1">
                                  <button
                                    onClick={() => setSeeMore(false)}
                                    className="underline font-semibold"
                                  >
                                    Hide
                                  </button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="py-5 flex items-center justify-between w-full">
                          <div className="w-[60%]">
                            <p className={"text-[12px] font-bold"}>
                              {DashboardData.guardian === "Hide"
                                ? "Section 1/5"
                                : "Section 1/6"}
                            </p>
                            <p
                              className={
                                "text-[16px] sm:text-[16px] md:text-[18px] lg:text-[18px] font-bold"
                              }
                            >
                              Tell us About Your Self
                            </p>
                            <p className={"text-[12px] font-bold"}>
                              Add Your Partner , Children and Pets
                            </p>
                          </div>
                          <div className="w-[30%] flex justify-end">
                            <Link
                              to={
                                "/make-will-online/about-yourself/edit-personal-details"
                              }
                            >
                              <button className="border-2 rounded-[5px] border-[#240642] bg-[#240642] text-white px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                Start Now
                              </button>
                            </Link>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="my-5">
                  <div
                    className={`border-[#d7d7d7] ${
                      DashboardData.guardian === "Hide" ? "hidden" : ""
                    }  rounded-lg border-2 pb-3 px-4 `}
                  >
                    {DashboardData.guardian !== "Hide" ? (
                      <>
                        {DashboardData.guardians ? (
                          <>
                            <div className="flex items-center justify-between mt-[16px]">
                              <h4 className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold ">
                                Guardians for children and pets
                              </h4>
                              {(DashboardData?.willStatus == "in_process" ||
                                DashboardData?.willStatus == "in_updating") && (
                                <div>
                                  <Link
                                    to={
                                      DashboardData.guardian === "Create"
                                        ? "/make-will-online/guardians"
                                        : `/guardian/review/list/${firstData.id}/${firstData.current_type}`
                                    }
                                  >
                                    <button
                                      className={`border-2 rounded-[5px] border-[#240642] px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px] ${
                                        DashboardData.guardian === "Create"
                                          ? "bg-[#240642] text-white"
                                          : "text-[#240642]"
                                      }`}
                                    >
                                      {DashboardData.guardian === "Create"
                                        ? "Start Now"
                                        : "Edit"}
                                    </button>
                                  </Link>
                                </div>
                              )}
                            </div>
                            {DashboardData.guardians?.map((items, index) => {
                              if (index === 0 || seeMoreGaurdian) {
                                return (
                                  <div key={index}>
                                    <p className="text-[16px] sm:text-[16px] lg:text-[18px]  font-bold py-3">
                                      Guardian {index + 1}
                                    </p>
                                    <div>
                                      <div className="flex w-full">
                                        <div className="w-[40%] text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                          <p>Name</p>
                                        </div>
                                        <div className="w-[60%]">
                                          <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                            {items.guardian_name}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="flex mt-2 w-full">
                                        <div className="w-[40%] text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                          <p> Guardian for</p>
                                        </div>
                                        <div className="w-[60%]">
                                          <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                            {items.guardianfor
                                              .map((item) => {
                                                return item.child_or_pet_name;
                                              })
                                              .join(", ")}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                              return null;
                            })}
                            {DashboardData.guardians?.length > 1 && (
                              <button
                                onClick={() =>
                                  setSeeMoreGaurdian(!seeMoreGaurdian)
                                }
                                className="underline text-[#240642] font-bold mt-2"
                              >
                                {seeMoreGaurdian ? "Hide" : "See More"}
                              </button>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      <>
                        {DashboardData.guardian === "Create" ? (
                          <div className="py-5 flex items-center justify-between">
                            <div className="w-[60%]">
                              <p
                                className={
                                  DashboardData.aboutYourself === "Edit"
                                    ? "text-[12px] font-bold"
                                    : "text-[#d7d7d7] text-[12px] font-bold"
                                }
                              >
                                {DashboardData.guardian === "Hide"
                                  ? "Section 2/5"
                                  : "Section 2/6"}
                              </p>
                              <p
                                className={
                                  DashboardData.aboutYourself === "Edit"
                                    ? "text-[16px] sm:text-[16px] md:text-[18px] lg:text-[18px] font-bold"
                                    : "text-[#d7d7d7] text-[16px] sm:text-[16px] md:text-[18px] lg:text-[18px] font-bold"
                                }
                              >
                                Choose guardians for loved ones
                              </p>
                              <p
                                className={
                                  DashboardData.aboutYourself === "Edit"
                                    ? "text-[12px] font-bold"
                                    : "text-[#d7d7d7] text-[12px] font-bold"
                                }
                              >
                                Pick who will look after your children and your
                                pet
                              </p>
                            </div>
                            <div className="w-[30%] flex justify-end">
                              <Link to={"/guardian/review"}>
                                <button className="border-2 rounded-[5px] border-[#240642] bg-[#240642] text-white px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  Start Now
                                </button>
                              </Link>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="my-5">
                  <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                    {DashboardData.estate === "Edit" ? (
                      <>
                        <div className="flex items-center justify-between mt-[16px]">
                          <h4 className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold ">
                            Divide your estate
                          </h4>
                          {(DashboardData?.willStatus == "in_process" ||
                            DashboardData?.willStatus == "in_updating") && (
                            <div>
                              <Link
                                to={
                                  DashboardData.estate === "Create"
                                    ? "/make-will-online/estate"
                                    : "/make-will-online/estate/beneficiaries"
                                }
                              >
                                <button className="border-2 rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  {DashboardData.estate == "Create"
                                    ? "Start Now"
                                    : "Edit"}
                                </button>
                              </Link>
                            </div>
                          )}
                        </div>
                        <div>
                          <p className="text-[16px] sm:text-[16px] lg:text-[18px]  font-bold pt-3">
                            Your Estate
                          </p>
                          <p className="text-[16px] sm:text-[16px] lg:text-[18px]  font-bold pb-3">
                            Your estate is split between:
                          </p>
                          <div>
                            {DashboardData.estates.estateCharitiesDetails?.map(
                              (charity, index) => (
                                <div key={index} className="flex mt-2">
                                  <div className="w-[40%]">
                                    <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                      Beneficiary
                                    </p>
                                  </div>
                                  <div className="w-[60%]">
                                    <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                      {charity.charity_name}
                                      {charity.charity_percentage !== null
                                        ? ` - ${charity.charity_percentage}%`
                                        : ""}
                                    </p>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                          <div>
                            {DashboardData.estates.estateBeneficiarDetails?.map(
                              (beneficiary, index) => (
                                <div key={index} className="flex mt-2">
                                  <div className="w-[40%]">
                                    <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                      Beneficiary
                                    </p>
                                  </div>
                                  <div className="w-[60%]">
                                    <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                      {beneficiary.name} -{" "}
                                      {beneficiary.percentage}%
                                    </p>
                                    <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                      {beneficiary.if_dies_estate_goes_to ===
                                      "children" ? (
                                        "If they die: their children will inherit their share"
                                      ) : beneficiary.if_dies_estate_goes_to ===
                                          "anything_else" &&
                                        beneficiary.if_dies_beneficiary.length >
                                          0 ? (
                                        <>
                                          If they die: their share will be
                                          inherited by{" "}
                                          {beneficiary.if_dies_beneficiary.map(
                                            (inheritor, idx) => {
                                              const isLast =
                                                idx ===
                                                beneficiary.if_dies_beneficiary
                                                  .length -
                                                  1;
                                              const isSecondLast =
                                                idx ===
                                                beneficiary.if_dies_beneficiary
                                                  .length -
                                                  2;
                                              return (
                                                <span key={idx}>
                                                  {inheritor.name} (
                                                  {inheritor.percentage}%)
                                                  {isLast
                                                    ? ""
                                                    : isSecondLast
                                                    ? " and "
                                                    : ", "}
                                                </span>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                    </p>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                        {!seeMoreGift ? (
                          <div className="mt-1">
                            <button
                              onClick={() => {
                                setSeeMoreGift(true);
                              }}
                              className="underline font-semibold"
                            >
                              See More
                            </button>
                          </div>
                        ) : (
                          <>
                            {DashboardData.gifts?.length > 0 && (
                              <div>
                                <p className="text-[16px] sm:text-[16px] lg:text-[18px]  font-bold py-3">
                                  Gifts from your estate
                                </p>
                              </div>
                            )}
                            {DashboardData.gifts?.map((gift, index) => {
                              return (
                                <div key={index} className="flex mt-2 w-full">
                                  <div className="w-[40%]">
                                    <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                      {gift.type_of_gift}
                                    </p>
                                  </div>
                                  <div className="w-[60%]">
                                    <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                      {gift.beneficiary_or_charity_name} -{" "}
                                      {gift.type_of_gift === "money"
                                        ? "A$ " + gift.leave_money_amount
                                        : gift.gift_description}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                            <div className="mt-3">
                              <button
                                onClick={() => setSeeMoreGift(false)}
                                className="underline font-semibold"
                              >
                                Hide
                              </button>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <div className="py-5 flex items-center justify-between w-full">
                        <div className="w-[60%]">
                          <p
                            className={
                              DashboardData.aboutYourself === "Edit"
                                ? "text-[12px] font-bold"
                                : "text-[#d7d7d7] text-[12px] font-bold"
                            }
                          >
                            {DashboardData.guardian === "Hide"
                              ? "Section 2/5"
                              : "Section 3/6"}
                          </p>
                          <p
                            className={
                              DashboardData.aboutYourself === "Edit"
                                ? "text-[16px] sm:text-[16px] md:text-[18px] lg:text-[18px] font-bold"
                                : "text-[#d7d7d7] text-[16px] sm:text-[16px] md:text-[18px] lg:text-[18px]  font-bold"
                            }
                          >
                            Divide your estate
                          </p>
                          <p
                            className={
                              DashboardData.aboutYourself === "Edit"
                                ? "text-[12px] font-bold"
                                : "text-[#d7d7d7] text-[12px] font-bold"
                            }
                          >
                            Decide What You'll Leave and to whom
                          </p>
                        </div>
                        <div className="w-[30%] flex justify-end">
                          {DashboardData.aboutYourself === "Edit" ? (
                            <Link to={"/make-will-online/estate"}>
                              <button className="border-2 rounded-[5px] border-[#240642] bg-[#240642] text-white px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                Start Now
                              </button>
                            </Link>
                          ) : (
                            <Link>
                              <button className="border-2 rounded-[5px] border-[#d7d7d7] bg-[#d7d7d7] text-white px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                Start Now
                              </button>
                            </Link>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="my-5">
                  <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                    {DashboardData.executor === "Edit" ? (
                      <>
                        <div className="flex items-center justify-between mt-[16px] w-full">
                          <h4 className="text-[16px] sm:text-[16px] lg:text-[18px]  font-bold font-bold ">
                            Executors
                          </h4>
                          {(DashboardData?.willStatus == "in_process" ||
                            DashboardData?.willStatus == "in_updating") && (
                            <div>
                              <Link to={"/make-will-online/executors/select"}>
                                <button className="border-2 rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  Edit
                                </button>
                              </Link>
                            </div>
                          )}
                        </div>
                        {DashboardData?.executors?.map((item, index) => {
                          return (
                            <div key={index} className="flex mt-2 w-full">
                              <div className="w-[40%]">
                                <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  Executor
                                </p>
                              </div>
                              <div className="w-[60%]">
                                <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                  {item}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div className="py-5 flex items-center justify-between w-full">
                        <div className="w-[60%]">
                          <p
                            className={
                              DashboardData.aboutYourself === "Edit"
                                ? "text-[12px] font-bold"
                                : "text-[#d7d7d7] text-[12px] font-bold"
                            }
                          >
                            {DashboardData.guardian === "Hide"
                              ? "Section 3/5"
                              : "Section 4/6"}
                          </p>
                          <p
                            className={
                              DashboardData.aboutYourself === "Edit"
                                ? "text-[16px] sm:text-[18px] md:text-[18px] lg:text-[18px] font-bold"
                                : "text-[#d7d7d7] text-[16px] sm:text-[18px] md:text-[18px] lg:text-[18px] font-bold"
                            }
                          >
                            Add your Executors
                          </p>
                          <p
                            className={
                              DashboardData.aboutYourself === "Edit"
                                ? "text-[12px] font-bold"
                                : "text-[#d7d7d7] text-[12px] font-bold"
                            }
                          >
                            Choose people to carry out your wishes
                          </p>
                        </div>
                        <div className="w-[30%] flex justify-end">
                          {DashboardData.aboutYourself === "Edit" ? (
                            <Link to={"/make-will-online/executors/intro-1"}>
                              <button className="border-2 rounded-[5px] border-[#240642] bg-[#240642] text-white px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                Start Now
                              </button>
                            </Link>
                          ) : (
                            <Link>
                              <button className="border-2 rounded-[5px] border-[#d7d7d7] bg-[#d7d7d7] text-white px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                Start Now
                              </button>
                            </Link>
                            // <Link to={"/make-will-online/executors/select"}>
                            //   <button className="border-2 rounded-[5px] border-[#d7d7d7] bg-[#d7d7d7] text-white px-4 py-1 font-bold">
                            //     Edit
                            //   </button>
                            // </Link>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="my-5">
                  <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                    {DashboardData.asset === "Edit" ? (
                      <>
                        <div className="flex items-center justify-between mt-[16px]">
                          <h4 className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold">
                            Assets
                          </h4>
                          <div>
                            <Link to="/make-will-online/assets/select">
                              <button className="border-2 rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                Edit
                              </button>
                            </Link>
                          </div>
                        </div>
                        {DashboardData.assets?.map((asset, index) => {
                          if (index === 0 || seeMoreAsset) {
                            return (
                              <div key={index} className="flex mt-2 w-full">
                                <div className="w-[40%]">
                                  <p className="text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                    Assets
                                  </p>
                                </div>
                                <div className="w-[60%]">
                                  <p className="font-semibold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                    {asset}
                                  </p>
                                </div>
                              </div>
                            );
                          }
                          return null;
                        })}
                        {DashboardData.assets?.length > 1 && (
                          <button
                            onClick={() => setSeeMoreAsset(!seeMoreAsset)}
                            className="underline  text-[#240642] font-bold mt-2"
                          >
                            {seeMoreAsset ? "Hide" : "See More"}
                          </button>
                        )}
                      </>
                    ) : (
                      <div className="py-5 flex items-center justify-between w-full">
                        <div className="w-[60%]">
                          <p
                            className={
                              DashboardData.aboutYourself === "Edit"
                                ? "text-[12px] font-bold"
                                : "text-[#d7d7d7] text-[12px] font-bold"
                            }
                          >
                            {DashboardData.guardian === "Hide"
                              ? "Section 4/5"
                              : "Section 5/6"}
                          </p>
                          <p
                            className={
                              DashboardData.aboutYourself === "Edit"
                                ? "text-[16px] sm:text-[18px] md:text-[18px] lg:text-[18px] font-bold"
                                : "text-[#d7d7d7] text-[16px] sm:text-[18px] md:text-[18px] lg:text-[18px] font-bold"
                            }
                          >
                            Identify Your Assets
                          </p>
                          <p
                            className={
                              DashboardData.aboutYourself === "Edit"
                                ? "text-[12px] font-bold"
                                : "text-[#d7d7d7] text-[12px] font-bold"
                            }
                          >
                            Helps your executors find your assets
                          </p>
                        </div>
                        <div className="w-[30%] flex justify-end">
                          {(DashboardData?.willStatus == "in_process" ||
                            DashboardData?.willStatus == "in_updating") && (
                            <div>
                              {DashboardData.aboutYourself === "Edit" ? (
                                <Link to={"/make-will-online/assets"}>
                                  <button className="border-2 rounded-[5px] border-[#240642] bg-[#240642] text-white px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                    Start Now
                                  </button>
                                </Link>
                              ) : (
                                <Link>
                                  <button className="border-2 rounded-[5px] border-[#d7d7d7] bg-[#d7d7d7] text-white px-4 py-1 font-bold text-[14px] sm:text-[16px] md:text-[16x] lg:text-[16px]">
                                    Start Now
                                  </button>
                                </Link>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="my-5">
                  <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                    <div className="text-[#d7d7d7] mt-[16px]">
                      <h4 className="text-[16px] sm:text-[18px] md:text-[20px] lg:text-[20px] text-[#d7d7d7] font-bold ">
                        Check and download
                      </h4>
                      <p className="text-[12px]">
                        Review, pay and download your will
                      </p>
                      {/* <div>
                    <Link>
                      <button className="border-2 rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold">
                        Edit
                      </button>
                    </Link>
                  </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="max-lg:hidden bg-no-repeat">
                <div className="fixed top-0 w-[500px] right-[6%] bg-cloud">
                  <img src="/assets/images/4.png" alt="mascot" />
                </div>
              </div>
            </div>
          </div>
          {DashboardData.will_completed &&
            DashboardData.payment_status === "unpaid" && (
              <div
                className="fixed gap-5 flex flex-col sm:flex-row items-center justify-center bottom-0 left-0 right-0 bg-[#fff] shadow-xl border-t border-gray-300 w-full h-auto sm:h-[110px] px-4 sm:px-6 lg:px-8 py-4 sm:py-0"
                style={{
                  boxShadow:
                    "0 -10px 15px -3px rgba(0, 0, 0, 0.1), 0 -4px 6px -2px rgba(0, 0, 0, 0.05)",
                }}
              >
                <p className="text-center text-[16px] sm:text-[18px] md:text-[20px] lg:text-[22px]">
                  <b>Keep going to make your will legal.</b> You can choose a
                  couples will in the next steps.
                </p>
                <Link to={"/make-will-online/subscription/almost-ready"}>
                  <button className="mt-3 sm:mt-0 sm:ml-4 border-2 rounded-[5px] border-[#240642] bg-primary text-white text-sm sm:text-base lg:text-lg px-4 sm:px-6 py-2 sm:py-3 font-bold">
                    Continue
                  </button>
                </Link>
              </div>
            )}

          {(DashboardData.willStatus == "in_updating" ||
            DashboardData.willStatus == "in_process") &&
            DashboardData.payment_status == "paid" &&
            DashboardData.will_completed === true && (
              <div
                className="fixed gap-5 flex flex-col sm:flex-row items-center justify-center bottom-0 left-0 right-0 bg-[#fff] shadow-xl border-t border-gray-300 w-full h-auto sm:h-[110px] rounded-lg px-4 sm:px-0"
                style={{
                  boxShadow:
                    "0 -10px 15px -3px rgba(0, 0, 0, 0.1), 0 -4px 6px -2px rgba(0, 0, 0, 0.05)",
                }}
              >
                <p className="text-center text-[18px] sm:text-[22px]">
                  <b>
                    {DashboardData.willStatus == "in_process"
                      ? "Submit Will"
                      : "Resubmit Will"}{" "}
                  </b>
                </p>
                <button
                  className="mt-3 sm:mt-0 sm:ml-4 border-2 rounded-[5px] border-[#240642] bg-primary text-white text-sm sm:text-base px-3 sm:px-4 py-1 sm:py-2 font-bold"
                  onClick={() =>
                    handleResubmitWill(
                      DashboardData.current_will_id,
                      DashboardData.admin_notes.note_id
                    )
                  }
                >
                  {DashboardData.willStatus == "in_process"
                    ? "Submit"
                    : "Resubmit Will"}
                </button>
              </div>
            )}
          {DashboardData.willStatus == "in_review" && (
            <div
              className="fixed gap-5 flex flex-col sm:flex-row items-center justify-center bottom25rem left-0 right-0 bg-[#fff] shadow-xl border-y border-gray-300 w-full h-auto sm:h-[110px] rounded-lg px-4 sm:px-0  py-5"
              style={{
                boxShadow:
                  "0 -10px 15px -3px rgba(0, 0, 0, 0.1), 0 -4px 6px -2px rgba(0, 0, 0, 0.05)",
              }}
            >
              <p className="text-center text-[18px] sm:text-[22px]">
                <b>You Are in Review Mode</b>
              </p>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Dashboard;
